import { createAPI } from '@common'
export default {
  getGroups: (config) => createAPI('customEncryptApiName-1/0w20hspvqt', 'GET', config),
  getMamSetting: (config) => createAPI('customEncryptApiName-1/0w20nbn0tfuujoh', 'GET', config),
  postMamSetting: (config) => createAPI('customEncryptApiName-1/0w20nbn0tfuujoh', 'POST', config),
  getNisLiveSetting: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0mjwf0tfuujoh', 'GET', config),
  postNisLiveSetting: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0mjwf0tfuujoh', 'POST', config),
  // 根据分组类型和id，获取name
  getMamGroupName: (config) => createAPI('customEncryptApiName-1/0w20nbn0hspvq0obnf', 'GET', config),
  // 根据分组类型和id，获取name
  getMamGroupNames: (config) => createAPI('customEncryptApiName-1/0w20nbn0hspvq0obnft', 'GET', config)
}
